import mongoose from "mongoose";

export interface EmailConfiguration {
  _id: mongoose.Schema.Types.ObjectId;
  category: string;
  customerId?: string;
  limitationType?: string;
  limitationValue?: string;
  roleIds: string[]; // may be empty
  emails: string[]; // may be empty
  emailMode: string;
}

export const EmailConfigurationSchema = new mongoose.Schema<EmailConfiguration>({
  category: { type: String, required: true },
  customerId: { type: String, required: false, default: () => null },
  limitationType: { type: String, required: false, default: () => null },
  limitationValue: { type: String, required: false, default: () => null },
  roleIds: { type: [String], required: true, default: () => [] },
  emails: { type: [String], required: true, default: () => [] },
  emailMode: { type: String, required: true, default: () => "to" },
});
